import store from '@/store'
import AppUtils from '@/utils/AppUtils'
import ApiUtils from '@/utils/api/ApiUtils'
import StoreUtils from '@/utils/StoreUtils'
import { PortalUtils } from '@/utils/PortalUtils.js'

// TODO: refactor 
export const authorizationCheck = async (to, from, next) => {
  // Abort all running AJAX API request before navigate to other route to increase performance
  ApiUtils.abortAll()

  // console.log('authorizationCheck.to', to)
  // console.log('authorizationCheck.from', from)
  // console.log('authorizationCheck.next', next)
  // debugger
  // NOTE: handle change portal
  if (to.meta && to.query.portal && to.query.portal !== PortalUtils.name) {
    let targetUrl = PortalUtils.getOrigin(to.query.portal).slice(0, -1)
    if (!targetUrl) next({ name: '404' })
    targetUrl += to.fullPath
    // remove portal query in url string, use URL API to remove query
    const url = new URL(targetUrl)
    url.searchParams.delete('portal')
    targetUrl = url.toString()
    // console.log('targetUrl', targetUrl)
    window.location.href = targetUrl
  }
  // TODO: remove to.query.portal if same as current portal

  if (to.name === 'portalError') return next()
  if (PortalUtils.checkIsLocalhost()) return next({ name: 'portalError' })

  // NOTE: check portal is valid in this route to.meta.portal
  if (to.meta && to.meta.portal && !to.meta.portal.includes(PortalUtils.name)) return next({ name: '404' })

  // Get the guards array from meta
  const {
    authenticated, roles, permissions,
    // notLogged, 
    debug
  } = to.meta

  if (debug && from.name !== 'AllCompsExample') {
    console.warn('Development only page!!\n if this page is production page, please remove `debug: true` in meta')
  }

  // Initialize user data if it is not initialized
  if (store.getters['Auth/getInit'] === null) {
    await StoreUtils.storeApiDispatch('Auth/init')
  }

  // If user tries to access route that needs authorization and not authenticated, will be redirected to login page
  if (authenticated && !AppUtils.isLoggedIn()) {
    return next({ name: 'Login', query: { next: to.fullPath } })
  }

  // If user is logged in and tries to access pages intended for non-logged in users, will be redirected accordingly
  // if (notLogged && AppUtils.isLoggedIn()) {
  //   return next({ name: 'Home' })
  // }

  // If App is not in debug mode and visit route requires debug mode
  if (debug && !AppUtils.isDebugMode()) {
    if (AppUtils.isLoggedIn()) {
      // If user is logged in, return to dashboard
      return next({ name: 'Home' })
    } else {
      return next({ name: 'Home' })
    }
  }

  // Check if user has correct role & permissions
  if (AppUtils.allowAccess(authenticated, roles, permissions)) {
    return next()
  } else if (AppUtils.isLoggedIn()) {
    // If user is logged in, return to dashboard
    return next({ name: 'Home' })
  }

  return next({ name: 'Home' })
}
